<template>
  <row class="law-cases-list" :gutter="16" type="flex" align="top">
    <i-col span="24" v-for="lawCase in lawCases" :key="lawCase.id">
      <law-cases-item :law-case="lawCase" :all="all" @open-law-case="openLawCase" />
    </i-col>
  </row>
</template>

<script>
import LawCasesItem from './law-cases-item'

export default {
  components: {
    LawCasesItem
  },
  props: ['law-cases', 'all'],
  methods: {
    openLawCase (payload) {
      this.$emit('open-law-case', payload)
    }
  }
}
</script>

<style>
</style>
